import {Component, Input, ViewChild} from '@angular/core';
import {
  RechercheModeleDto, ModeleFormulaireLightDto, IModeleFormulaireWebServiceClient,
  PaginationModeleResultDto,
  RechercheModeleTriEnum,
} from '@common/resources/resources';
import {AsiTableSelectionModel, AsiTableRequest, AsiTableData, AsiTable} from "@asi-ngtools/lib";
import {ModalService, NotificationService} from "@digicerba/common";
import * as lodash from "lodash";

@Component({
  selector: 'resultats',
  templateUrl: './resultats.component.html',
})
export class ResultatsComponent {

  @Input() rechercheModeleDto: RechercheModeleDto;

  @ViewChild('modelesDataTable') modeleTable: AsiTable<ModeleFormulaireLightDto>;
  asiTableData: AsiTableData<ModeleFormulaireLightDto> = new AsiTableData<ModeleFormulaireLightDto>();
  searchHasTooManyResults: boolean;
  selectionModel = new AsiTableSelectionModel("id", false);
  currentSearchDto: RechercheModeleDto;
  tries: Array<{ code: RechercheModeleTriEnum, libelle: string }>;
  tri: RechercheModeleTriEnum;

  constructor(private notificationService: NotificationService,
              private modalService: ModalService,
              private modeleFormulaireWebService: IModeleFormulaireWebServiceClient) {
    this.tries = new Array();
    this.tries.push({code: 'TITRE', libelle: "PAGE.DOSSIERS_BLOQUES.TRI.titre"});
    this.tries.push({code: 'CATEGORIE', libelle: "PAGE.DOSSIERS_BLOQUES.TRI.categorie"});
  }

  refreshTable(asiTableRequest: AsiTableRequest) {
    this.currentSearchDto = {...asiTableRequest, ...this.rechercheModeleDto};
    this.rechercheModele();
  }

  ngOnChanges() {
    this.modeleTable.fireRefresh();
  }


  sortData(code: RechercheModeleTriEnum) {
    this.currentSearchDto.tri = code;
    this.rechercheModele();
  }

  private rechercheModele() {
    this.modeleFormulaireWebService.searchModeleFormulaireAdmin(this.currentSearchDto).subscribe((resultats: PaginationModeleResultDto) => {
      // affichage du message si les critères de recherches sont trop larges.
      this.searchHasTooManyResults = resultats.limitExceeded;
      this.asiTableData = {...resultats.pagination, paginate: true};
      this.modeleTable.updateData(this.asiTableData);
    }, () => {
      this.notificationService.showErrorNotification("ERRORS.unprocessable");
    });
  }

  openDeleteModal(id: number) {
    this.modalService.openConfirmDialog("MODAL.SUPPRESSION.titre", "MODAL.SUPPRESSION.MODELE.message",
      "MODAL.CONFIRM.cancel", "MODAL.CONFIRM.confirm").onDialogCancel().subscribe(() => {
      this.modeleFormulaireWebService.supprimerModeleFormulaire(id).subscribe(_response => {
        lodash.remove(this.asiTableData.results, function (o) {
          return o.id == id;
        });
        this.modeleTable.updateData(this.asiTableData);
      }, () => {
        this.modalService.openInfoDialog("MODAL.SUPPRESSION.IMPOSSIBLE.titre", "MODAL.SUPPRESSION.IMPOSSIBLE.message",
          "MODAL.SUPPRESSION.IMPOSSIBLE.validation").onDialogClose().subscribe(() => {
        });
      });
    });
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/pages/cerba/pages/admin/dossier-bloques-modele/resultats/resultats.component.ts